import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { SidebarProvider } from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'

export const Route = createFileRoute('/_authenticated/_sidebar')({
	component: SidebarLayoutComponent,
})

export function SidebarLayoutComponent() {
	const defaultOpen = true

	return (
		<SidebarProvider defaultOpen={defaultOpen}>
			<AppSidebar />
			<div
				id="content"
				className={cn(
					'ml-auto w-full max-w-full',
					'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
					'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
					'sm:transition-[width] sm:duration-200 sm:ease-linear',
					'flex h-svh flex-col',
					'group-data-[scroll-locked=1]/body:h-full',
					'has-[main.fixed-main]:group-data-[scroll-locked=1]/body:h-svh',
				)}
			>
				<Outlet />
			</div>
		</SidebarProvider>
	)
}
